import { Dispatch, SetStateAction } from 'react';
import { ace_index } from '@axo/shared/data-access/types';
import { FilterSelect } from '../FilterSelect';
import { areObjectsDifferent } from '../../utils/compareObjects';
import { setPageNumber } from '../SearchResults';

interface Props {
  query: ace_index.FindInput;
  setQuery: Dispatch<SetStateAction<ace_index.FindInput>>;
  editable?: boolean;
}

export function MultipleApprovedQuotes({
  query,
  setQuery,
  editable = false,
}: Props) {
  const state = getNumApprovedQuotes(query);
  const value =
    options.find((option) => !areObjectsDifferent(option.value, state)) ??
    options[0];

  return (
    <FilterSelect
      items={options}
      onSelect={(option) => setQuery(setNumApprovedQuotes(option.value))}
      stringify={(option) => option.label}
      value={value}
      label="Number of approved quotes"
      description="Filter number of approved quotes on application."
      disabled={!editable}
    />
  );
}

const options: {
  label: string;
  value: Value;
}[] = [
  {
    label: 'All',
    value: undefined,
  },
  {
    label: 'Approved 1',
    value: { From: 1, To: 2 },
  },
  {
    label: 'Approved 1+',
    value: { From: 1 },
  },
];

function setNumApprovedQuotes(
  range: Value
): SetStateAction<ace_index.FindInput> {
  return (query) => ({
    ...setPageNumber(1)(query),
    SummaryNumApprovedQuotes: range,
  });
}

function getNumApprovedQuotes(query: ace_index.FindInput) {
  return query.SummaryNumApprovedQuotes;
}

type Value = ace_index.FindInput['SummaryNumApprovedQuotes'];
